import { account, error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const DestinationAccountsQuery = gql`
  query GetDestinationAccounts($input: TransferOptionsInput) {
    transferOptions(input: $input) {
      ... on TransferOptions {
        destination {
          ... on GroupedAccounts {
            internal {
              ...account
            }
            external {
              ...account
            }
          }
        }
        type
        maxTransfer {
          ...money
        }
        transferEstimate
      }
      ... on TransferNotPossibleError {
        ...error
      }
    }
  }
  ${account}
  ${money}
  ${error}
`;

export default DestinationAccountsQuery;
